import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { useModel } from '../model'
import { usePrintModel } from "./printModel";
import { useNavModel } from '@/model/navModel'
import YhTootip from '@/components/YhTootip'
import { momentFormat } from '@/utils/utils'
import { YhTableSort } from '@/components/YhTableSort'
import { commonService } from '@/service/common'
import { SettingOutlined, PrinterOutlined } from '@ant-design/icons'
import { setStatusTag } from '@/App'

const sortKey = 'outWarehouse'

export function DataTable() {
    const { dataSource, pgCfg, updateEditFormVal, loadData, columnsSetVisible, setColumnsSetVisible, orders, loading } = useModel()
    const { addNav, findNav, switchNavState } = useNavModel(() => [])
    const {
        setId, setScmSalePV, setScmPurcharseReturnPV,
        setCode, setBcmSalePV, setBcmPurcharseReturnPV, setBcmPresalePV,
        setVrmSalePV, setVrmPurcharseReturnPV, setVrmMaintenancePV,
        setCiSalePV, setCiPurcharseReturnPV, setCiMaintenancePV,
    } = usePrintModel()

    useEffect(() => {
        loadData()
        getColumns()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onEdit = (record) => {
        let supplierEditKey = '3-1-1'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.id, mode: 'edit' })
            updateEditFormVal(null)
            window.sessionStorage.setItem('outWarehouseDetails', JSON.stringify(record))
        } else {
            switchNavState(supplierEditKey, { id: record?.id, mode: 'edit' })
            updateEditFormVal(null)
            window.sessionStorage.setItem('outWarehouseDetails', JSON.stringify(record))
        }
    }

    const getRegularColumns = [
        {
            title: (
                <>
                    <span>
                        <SettingOutlined
                            onClick={() => {
                                setColumnsSetVisible(true)
                            }}
                        />
                    </span>
                    <span>序号</span>
                </>
            ),
            width: 80,
            fixed: 'left',
            align: 'center',
            render: (t, r, i) => i + 1,
        },
    ]
    const defaultColumns = [
        {
            title: '分支编码',
            width: 100,
            dataIndex: 'branch',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '门店名称',
            width: 140,
            dataIndex: 'shopName',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '单位名称',
            width: 220,
            dataIndex: 'orgName',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '220px' }} />,
        },
        {
            title: '出库单号',
            width: 200,
            dataIndex: 'code',
            sorter: true,
            isSet: true,
            render: (t, r) => (
                <>
                    <YhTootip
                        onClick={() => {
                            onEdit(r)
                        }}
                        text={r.code}
                        style={{ width: '200px', color: '#4165E3', cursor: 'pointer', display: 'inline', marginRight: 10 }}
                    />
                    <PrinterOutlined onClick={() => { showPrint(r); }} />
                </>
            ),
        },
        {
            title: '出库时间',
            width: 160,
            dataIndex: 'stockIoTime',
            sorter: true,
            isSet: true,
            render: (text) => momentFormat(text),
        },
        {
            title: '出库数量',
            width: 100,
            dataIndex: 'num',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '出库类型',
            width: 100,
            dataIndex: 'tradeTypeName',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '单据状态',
            width: 100,
            dataIndex: 'status',
            sorter: true,
            isSet: true,
            render: (text) => {
                return setStatusTag(text)
            },
        },
        {
            title: '制单员',
            width: 100,
            dataIndex: 'createUser',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '制单时间',
            width: 160,
            dataIndex: 'createTime',
            sorter: true,
            isSet: true,
            render: (text) => momentFormat(text),
        },
        {
            title: '库管员',
            width: 100,
            dataIndex: 'storekeeper',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
    ]

    const [columns, setColumns] = useState<any[]>([])

    const getColumns = () => {
        commonService.userCustomizeConfigOne(sortKey).then((res) => {
            if (!res.retData) {
                setColumns([...getRegularColumns, ...defaultColumns])
            } else {
                let newColumns: any[] = [...getRegularColumns]
                let data = JSON.parse(res.retData.val)
                data.forEach((element) => {
                    if (element.isShow) {
                        newColumns.push({ ...defaultColumns.find((i) => i.dataIndex === element.key), sorter: element.isSort })
                    }
                })
                setColumns(newColumns)
            }
        })
    }

    const onSuccess = () => {
        setColumnsSetVisible(false)
        getColumns()
    }

    const onChange = (pagination, filters, sorter) => {
        if (sorter.field) {
            if (sorter.order) {
                orders.current = [{ column: sorter.field, asc: sorter.order === 'ascend' }]
            } else {
                orders.current = []
            }
            loadData()
        }
    }

    const showPrint = (record) => {
        setId(record.id);
        setCode(record.code);
        if (record.branch === "scm") {
            record.tradeTypeCode === "trade-type.purchase-return" ? setScmPurcharseReturnPV(true) : setScmSalePV(true);
        }
        if (record.branch === "bcm") {
            record.tradeTypeCode === "trade-type.purchase-return" ? setBcmPurcharseReturnPV(true)
                : record.tradeTypeCode === "trade-type.presale-order" ? setBcmPresalePV(true) : setBcmSalePV(true);
        }
        if (record.branch === "vrm") {
            record.tradeTypeCode === "trade-type.purchase-return" ? setVrmPurcharseReturnPV(true)
                : record.tradeTypeCode === "trade-type.sale" ? setVrmSalePV(true) : setVrmMaintenancePV(true);
        }

        if (record.branch === "ci") {
            record.tradeTypeCode === "trade-type.purchase-return" ? setCiPurcharseReturnPV(true)
                : record.tradeTypeCode === "trade-type.sale" ? setCiSalePV(true) : setCiMaintenancePV(true);
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id || record.index}
                onChange={onChange}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
            />
            <YhTableSort
                sortKey={sortKey}
                visible={columnsSetVisible}
                setVisible={setColumnsSetVisible}
                defaultColumns={defaultColumns}
                onSuccess={onSuccess}
            />

        </>
    )
}
